                                        import type * as Types from "../types";
      export type Filtertypes ={
            architecture: Types.ArchitectureOperationFilterInput;
            assetTypeCategory: Types.AssetTypeCategoryOperationFilterInput;
            bomFormat: Types.BomFormatOperationFilterInput;
            boolean: Types.BooleanOperationFilterInput;
            dateTime: Types.ComparableDateTimeOperationFilterInput;
            guid: Types.ComparableGuidOperationFilterInput;
            int: Types.ComparableInt32OperationFilterInput;
            int64: Types.ComparableInt64OperationFilterInput;
            dependencyTrackScanSource: Types.DependencyTrackScanSourceOperationFilterInput;
            entityChangeType: Types.EntityChangeTypeOperationFilterInput;
            moduleHealthStatus: Types.ModuleHealthStatusOperationFilterInput;
            sbomFormat: Types.SbomFormatOperationFilterInput;
            signalLogLevel: Types.SignalLogLevelOperationFilterInput;
            string: Types.StringOperationFilterInput;
            tenantState: Types.TenantStateOperationFilterInput;
            updateActionStatus: Types.UpdateActionStatusOperationFilterInput;
            updateActionType: Types.UpdateActionTypeOperationFilterInput;
            updateComponent: Types.UpdateComponentOperationFilterInput;
            updatePhase: Types.UpdatePhaseOperationFilterInput;
            uplinkMode: Types.UplinkModeOperationFilterInput;}
    
    export const filterdefs = {
  "architecture": [
    "eq",
    "neq"
  ],
  "assetTypeCategory": [
    "eq",
    "neq"
  ],
  "bomFormat": [
    "eq",
    "neq"
  ],
  "boolean": [
    "eq",
    "neq"
  ],
  "dateTime": [
    "eq",
    "gt",
    "gte",
    "lt",
    "lte",
    "neq",
    "ngt",
    "ngte",
    "nlt",
    "nlte"
  ],
  "guid": [
    "eq",
    "gt",
    "gte",
    "lt",
    "lte",
    "neq",
    "ngt",
    "ngte",
    "nlt",
    "nlte"
  ],
  "int": [
    "eq",
    "gt",
    "gte",
    "lt",
    "lte",
    "neq",
    "ngt",
    "ngte",
    "nlt",
    "nlte"
  ],
  "int64": [
    "eq",
    "gt",
    "gte",
    "lt",
    "lte",
    "neq",
    "ngt",
    "ngte",
    "nlt",
    "nlte"
  ],
  "dependencyTrackScanSource": [
    "eq",
    "neq"
  ],
  "entityChangeType": [
    "eq",
    "neq"
  ],
  "moduleHealthStatus": [
    "eq",
    "neq"
  ],
  "sbomFormat": [
    "eq",
    "neq"
  ],
  "signalLogLevel": [
    "eq",
    "neq"
  ],
  "string": [
    "contains",
    "endsWith",
    "eq",
    "ncontains",
    "nendsWith",
    "neq",
    "nstartsWith",
    "startsWith"
  ],
  "tenantState": [
    "eq",
    "neq"
  ],
  "updateActionStatus": [
    "eq",
    "neq"
  ],
  "updateActionType": [
    "eq",
    "neq"
  ],
  "updateComponent": [
    "eq",
    "neq"
  ],
  "updatePhase": [
    "eq",
    "neq"
  ],
  "uplinkMode": [
    "eq",
    "neq"
  ]
}